module.exports = __webpack_public_path__ + "img/verificationComplete.38719daa.jpg";